module.exports = __webpack_public_path__ + "static/media/clouds.61c4e000.png";